import { useEffect } from 'react';
const useUpdateData = (target, type, value) => {
  useEffect(() => {
    if (target) {
      target.dispatchEvent(new CustomEvent('data_update', {
        detail: {
          type,
          value
        }
      }));
    }
  }, [target, type, value]);
};
export default useUpdateData;